"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
} from "../../../../../../public/images/blogs/bungalowFloorPlan";

export default function BlogContent() {
  const t = useTranslations("blogs.bungalowFloorPlan");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/baufinanzierung">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/immobilienmarketing">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
            link4: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/bemasster-grundriss">{chunks}</BlogLink>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/baufinanzierung">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/bemasster-grundriss-fuer-bank">
                {chunks}
              </BlogLink>
            ),
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section5.title")}
          text={t.rich("sections.section5.text", {
            br: () => <br></br>,
            link: (chunks) => <BlogLink href="/blog/expose">{chunks}</BlogLink>,
            link1: (chunks) => (
              <BlogLink href="/blog/wohnflaechenberechnung-din277">
                {chunks}
              </BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
          })}
          src={section5}
          alt={t("sections.section5.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section6.title")}
          text={t.rich("sections.section6.text", {
            br: () => <br></br>,
            link: (chunks) => <BlogLink href="/blog/expose">{chunks}</BlogLink>,
            link1: (chunks) => (
              <BlogLink href="/blog/unterlagen-fuer-eine-baufinanzierung">
                {chunks}
              </BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/bemasster-grundriss">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/wohnflaechenberechnung-din277">
                {chunks}
              </BlogLink>
            ),
          })}
          src={section6}
          alt={t("sections.section6.imageAlt")}
          disclaimer="default"
        />
      </div>
    </>
  );
}
